import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  AccountByCompany,
  AggregatedStatus,
  BuildingInfo,
  CompanyUser,
  DocumentType,
  EquipmentDocumentResponse,
  GetResponse,
  InstallationMonetizationFeatures,
  SubscriptionWithPaidFeatures,
  ViCarePlan,
  ViError,
} from '@vi-iot/client';

import {
  BasicInformationInstallation,
  DashboardTypes,
  InstallationDevicePanels,
  InstallationPanelOrder,
} from './installation-details.model';
export namespace InstallationDetailsActions {
  export enum Type {
    GET_PANELS_ORDER = '[INSTALLATION DETAILS] Get Panels Order',
    GET_PANELS_ORDER_SUCCESS = '[INSTALLATION DETAILS] Get Panels Order Success',
    GET_PANELS_ORDER_ERROR = '[INSTALLATION DETAILS] Get Panels Order Error',
    SAVE_PANELS_ORDER = '[INSTALLATION DETAILS] Save Panels Order',
    SAVE_PANELS_ORDER_SUCCESS = '[INSTALLATION DETAILS] Save Panels Order Success',
    SAVE_PANELS_ORDER_ERROR = '[INSTALLATION DETAILS] Save Panels Order Error',
    READ_INSTALLATION_DETAILS = '[INSTALLATION DETAILS] Read Installation Details',
    READ_INSTALLATION_DETAILS_SUCCESS = '[INSTALLATION DETAILS] Read Installation Details Success',
    READ_INSTALLATION_DETAILS_ERROR = '[INSTALLATION DETAILS] Read Installation Details Error',
    STOP_MONITORING = '[INSTALLATION DETAILS] Stop Monitoring',
    STOP_MONITORING_SUCCESS = '[INSTALLATION DETAILS] Stop Monitoring Success',
    STOP_MONITORING_ERROR = '[INSTALLATION DETAILS] Stop Monitoring Error',
    LIVE_UPDATE_AGGREGATED_STATUS = '[INSTALLATION DETAILS] Live Update Aggregated Status',
    NOT_FOUND = '[INSTALLATION DETAILS] Not Found',
    READ_USER_PAID_FEATURES = '[INSTALLATION DETAILS] Read User Paid Features',
    READ_USER_PAID_FEATURES_SUCCESS = '[INSTALLATION DETAILS] Read User Paid Features Success',
    READ_USER_PAID_FEATURES_ERROR = '[INSTALLATION DETAILS] Read User Paid Features Error',
    GET_MAINTENANCE_CHECKLIST = '[INSTALLATION DETAILS] Get Maintenance Checklist',
    GET_MAINTENANCE_CHECKLIST_SUCCESS = '[INSTALLATION DETAILS] Get Maintenance Checklist Success',
    GET_MAINTENANCE_CHECKLIST_ERROR = '[INSTALLATION DETAILS] Get Maintenance Checklist Error',
    GET_SERVICE_INSTRUCTION = '[INSTALLATION DETAILS] Get Service Instruction',
    GET_SERVICE_INSTRUCTION_IN_DEFAULT_LANGUAGE = '[INSTALLATION DETAILS] Get Service Instruction In Default Language',
    GET_SERVICE_INSTRUCTION_SUCCESS = '[INSTALLATION DETAILS] Get Service Instruction Success',
    GET_SERVICE_INSTRUCTION_ERROR = '[INSTALLATION DETAILS] Get Service Instruction Error',
    SELECT_DEVICE_ON_STARTUP = '[INSTALLATION DETAILS] Select device on startup',
    SAVE_PANELS_ORDER_MOBILE = '[INSTALLATION DETAILS] Save Panels Order Mobile',
    SAVE_PANELS_ORDER_MOBILE_SUCCESS = '[INSTALLATION DETAILS] Save Panels Order Mobile Success',
    SAVE_PANELS_ORDER_MOBILE_ERROR = '[INSTALLATION DETAILS] Save Panels Order Mobile Error',
    FETCH_ECOWATER_FEATURES = '[INSTALLATION DETAILS] Fetch Ecowater Features',
    FETCH_SOLAR_LOG_INVERTER_FEATURES = '[INSTALLATION DETAILS] Fetch Solar Log Inverter Features',
    FETCH_WALLBOX_FEATURES = '[INSTALLATION DETAILS] Fetch Wallbox Features',
    UPDATE_BUILDING_INFO = '[INSTALLATION DETAILS] Update building info',
    UPDATE_BUILDING_INFO_SUCCESS = '[INSTALLATION DETAILS] Update building info success',
    UPDATE_BUILDING_INFO_ERROR = '[INSTALLATION DETAILS] Update building info error',
    VERIFY_HEMS_PACKAGE_PRESENCE = '[INSTALLATION DETAILS] Verify HEMS package presence',
    GET_VICARE_PLANS = '[INSTALLATION DETAILS] Get ViCare Plans',
    GET_VICARE_PLANS_SUCCESS = '[INSTALLATION DETAILS] Get ViCare Plans Success',
    GET_VICARE_PLANS_ERROR = '[INSTALLATION DETAILS] Get ViCare Plans Error',
    TRIGGER_MONETIZATION_FEATURES = '[INSTALLATION DETAILS] Trigger Get Monetization Features',
    GET_MONETIZATION_FEATURES = '[INSTALLATION DETAILS] Get Monetization Features',
    GET_MONETIZATION_FEATURES_SUCCESS = '[INSTALLATION DETAILS] Get Monetization Features Success',
    GET_MONETIZATION_FEATURES_ERROR = '[INSTALLATION DETAILS] Get Monetization Features Error',
    GET_PERMAMENT_INSPECTION_FEATURE_SUPPORT = '[INSTALLATION DETAILS] Get Permament Inspection Feature Support',
    GET_PERMAMENT_INSPECTION_FEATURE_SUPPORT_SUCCESS = '[INSTALLATION DETAILS] Get Permament Inspection Feature Support Success',
    DEREGISTER_GATEWAY = '[INSTALLATIONS] Deregister Gateway',
    DEREGISTER_GATEWAY_SUCCESS = '[INSTALLATIONS] Deregister Gateway Success',
    DEREGISTER_GATEWAY_ERROR = '[INSTALLATIONS] Deregister Gateway Error',
    RESET_DEREGISTER_STATE = '[INSTALLATIONS] Reset Deregister State',
    REFRESH_DEVICE_LIST = '[INSTALLATION DETAILS] Refresh Device List',
    REFRESH_DEVICE_LIST_SUCCESS = '[INSTALLATION DETAILS] Refresh Device List Success',
    REFRESH_DEVICE_LIST_ERROR = '[INSTALLATION DETAILS] Refresh Device List Error',
    SELECT_DASHBOARD_TYPE = '[INSTALLATION DETAILS] Select Dashboard Type Helper',
    GET_MAINTAINER_EMPLOYEES_LIST = '[INSTALLATION DETAILS] Get Access List Maintainer List',
  }

  export const selectDashboardTypeHelper = createAction(
    Type.SELECT_DASHBOARD_TYPE,
    props<{ dashboardType: DashboardTypes }>()
  );

  export const ReadInstallationDetails = createAction(
    Type.READ_INSTALLATION_DETAILS,
    props<{ installationId: number }>()
  );

  export const getPermamentInspectionFeatureSupport = createAction(
    Type.GET_PERMAMENT_INSPECTION_FEATURE_SUPPORT,
    props<{ deviceSerial: string }>()
  );

  export const getPermamentInspectionFeatureSupportSuccess = createAction(
    Type.GET_PERMAMENT_INSPECTION_FEATURE_SUPPORT_SUCCESS,
    props<{ isSupported: boolean }>()
  );

  export const ReadInstallationDetailsSuccess = createAction(
    Type.READ_INSTALLATION_DETAILS_SUCCESS,
    props<{ payload: BasicInformationInstallation }>()
  );

  export const ReadInstallationDetailsError = createAction(
    Type.READ_INSTALLATION_DETAILS_ERROR,
    props<{ error: any }>()
  );

  export const GetPanelsOrder = createAction(
    Type.GET_PANELS_ORDER,
    props<{ gatewaySerial: string }>()
  );

  export const GetPanelsOrderSuccess = createAction(
    Type.GET_PANELS_ORDER_SUCCESS,
    props<{ panelsOrder: InstallationDevicePanels }>()
  );

  export const GetPanelsOrderError = createAction(
    Type.GET_PANELS_ORDER_ERROR,
    props<{ error: any }>()
  );

  export const GetViCarePlans = createAction(
    Type.GET_VICARE_PLANS,
    props<{ installationId: number }>()
  );

  export const GetViCarePlansSuccess = createAction(
    Type.GET_VICARE_PLANS_SUCCESS,
    props<{ plans: ViCarePlan[] }>()
  );

  export const GetViCarePlansError = createAction(
    Type.GET_VICARE_PLANS_ERROR,
    props<{ error: any }>()
  );

  export const TriggerGetMonetizationFeatures = createAction(
    Type.TRIGGER_MONETIZATION_FEATURES,
    props<{ installationId: number }>()
  );

  export const GetMonetizationFeatures = createAction(
    Type.GET_MONETIZATION_FEATURES,
    props<{ installationId: number }>()
  );

  export const GetMonetizationFeaturesSuccess = createAction(
    Type.GET_MONETIZATION_FEATURES_SUCCESS,
    props<{ monetizationFeatures: GetResponse<InstallationMonetizationFeatures> }>()
  );

  export const GetMonetizationFeaturesError = createAction(
    Type.GET_MONETIZATION_FEATURES_ERROR,
    props<{ error: any }>()
  );

  export const SavePanelsOrder = createAction(
    Type.SAVE_PANELS_ORDER,
    props<{ deviceId: string; panelsOrder: InstallationPanelOrder[] }>()
  );

  export const SavePanelsOrderSuccess = createAction(Type.SAVE_PANELS_ORDER_SUCCESS);

  export const SavePanelsOrderError = createAction(
    Type.SAVE_PANELS_ORDER_ERROR,
    props<{ error: any }>()
  );

  export const StopMonitoring = createAction(Type.STOP_MONITORING, props<{ ownerName: string }>());

  export const StopMonitoringSuccess = createAction(Type.STOP_MONITORING_SUCCESS);

  export const StopMonitoringError = createAction(
    Type.STOP_MONITORING_ERROR,
    props<{ error: any }>()
  );

  export const LiveUpdateAggregatedStatus = createAction(
    Type.LIVE_UPDATE_AGGREGATED_STATUS,
    props<{
      gatewaySerial: string;
      aggregatedStatus: AggregatedStatus;
      lastChangedAt: string;
    }>()
  );

  export const NotFound = createAction(Type.NOT_FOUND);

  export const ReadUserPaidFeatures = createAction(
    Type.READ_USER_PAID_FEATURES,
    props<{ boilerSerial: string }>()
  );

  export const ReadUserPaidFeaturesSuccess = createAction(
    Type.READ_USER_PAID_FEATURES_SUCCESS,
    props<{ deviceWithPaidFeatures: SubscriptionWithPaidFeatures }>()
  );

  export const ReadUserPaidFeaturesError = createAction(
    Type.READ_USER_PAID_FEATURES_ERROR,
    props<{ error: any }>()
  );

  export const GetMaintenanceChecklist = createAction(Type.GET_MAINTENANCE_CHECKLIST);

  export const GetMaintenanceChecklistSuccess = createAction(
    Type.GET_MAINTENANCE_CHECKLIST_SUCCESS,
    props<{ maintenanceChecklist: EquipmentDocumentResponse[] }>()
  );

  export const GetMaintenanceChecklistError = createAction(
    Type.GET_MAINTENANCE_CHECKLIST_ERROR,
    props<{ error: any }>()
  );

  export const GetServiceInstruction = createAction(
    Type.GET_SERVICE_INSTRUCTION,
    props<{ documentTypes: DocumentType[] }>()
  );

  export const GetServiceInstructionSuccess = createAction(
    Type.GET_SERVICE_INSTRUCTION_SUCCESS,
    props<{ serviceInstruction: EquipmentDocumentResponse[] }>()
  );

  export const GetServiceInstructionError = createAction(
    Type.GET_SERVICE_INSTRUCTION_ERROR,
    props<{ error: any }>()
  );

  export const GetServiceInstructionDefaultLanguage = createActionGroup({
    source: Type.GET_SERVICE_INSTRUCTION_IN_DEFAULT_LANGUAGE,
    events: {
      attempt: props<{ documentTypes: DocumentType[] }>(),
      success: props<{ serviceInstruction: EquipmentDocumentResponse[] }>(),
      error: props<{ error: any }>(),
    },
  });

  export const SelectDeviceOnStartup = createAction(
    Type.SELECT_DEVICE_ON_STARTUP,
    props<{ gatewaySerial: string }>()
  );

  export const SavePanelsOrderMobile = createAction(
    Type.SAVE_PANELS_ORDER_MOBILE,
    props<{ panelsOrder: InstallationDevicePanels }>()
  );

  export const SavePanelsOrderMobileSuccess = createAction(Type.SAVE_PANELS_ORDER_MOBILE_SUCCESS);

  export const SavePanelsOrderMobileError = createAction(Type.SAVE_PANELS_ORDER_MOBILE_ERROR);

  export const deregisterGateway = createAction(
    Type.DEREGISTER_GATEWAY,
    props<{
      installationId: number;
      gatewaySerial: string;
    }>()
  );

  export const deregisterGatewaySuccess = createAction(
    Type.DEREGISTER_GATEWAY_SUCCESS,
    props<{
      installationId: number;
      gatewaySerial: string;
    }>()
  );

  export const deregisterGatewayError = createAction(Type.DEREGISTER_GATEWAY_ERROR);

  export const refreshDeviceList = createAction(
    Type.REFRESH_DEVICE_LIST,
    props<{
      installationId: number;
      gatewaySerial: string;
    }>()
  );

  export const refreshDeviceListSuccess = createAction(Type.REFRESH_DEVICE_LIST_SUCCESS);

  export const refreshDeviceListError = createAction(Type.REFRESH_DEVICE_LIST_ERROR);

  export const resetDeregisterState = createAction(Type.RESET_DEREGISTER_STATE);

  export const getEmployeesList = createActionGroup({
    source: Type.GET_MAINTAINER_EMPLOYEES_LIST,
    events: {
      attempt: props<{ customerNumber: number }>(),
      success: props<{ employees: CompanyUser[]; customerNumber: number }>(),
      error: props<{ error: ViError; customerNumber: number }>(),
    },
  });

  export const updateBuildingInfo = createActionGroup({
    source: '[INSTALLATION DETAILS] Update building info',
    events: {
      attempt: props<{ buildingInfo: BuildingInfo }>(),
      success: props<{ buildingInfo: BuildingInfo }>(),
      error: props<{ error: any }>(),
    },
  });

  export const getAccountsByCompany = createActionGroup({
    source: '[INSTALLATION DETAILS] Get accounts by company',
    events: {
      attempt: emptyProps(),
      success: props<{
        accountsByCompany: AccountByCompany;
      }>(),
      error: emptyProps(),
    },
  });

  export const getUserSubscriptionFeatures = createActionGroup({
    source: '[INSTALLATION DETAILS] Get User Subscription Features',
    events: {
      attempt: emptyProps(),
      success: props<{ viCareSubscriptions: ViCarePlan[] }>(),
      error: props<{ error: ViError }>(),
    },
  });
}
